import { FacebookProvider, EmbeddedPost } from "react-facebook";
import React from "react";
import { Box } from "grommet";

interface Props {
    link: string;
}
export const FacebookEmbed: React.FC<Props> = (props) => {

    return (
        <Box justify="center" align="center">
            <FacebookProvider appId="706715696870284">
                <EmbeddedPost href={props.link} width="600" />
            </FacebookProvider>
        </Box>
    )
}